module.exports = __webpack_public_path__ + "img/companion_1.9732f1cf.svg";